import { getBorderBase, getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import Button from 'components/Button';
import SearchInput from 'components/Controls/SearchInput';
import SwitchInput from 'components/Controls/SwitchInput';
import Tag from 'components/Tags/Tag';
import Typography from 'components/Typography';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', COMPONENTS_NAMES.FILTERS];

export const StyledFilterButton = styled(Button)`
  white-space: nowrap;
`;

export const BodyWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: auto;
  scrollbar-gutter: stable;
  padding-top: 3px;
  display: flex;
  flex-direction: column;
`;

export const NotFoundWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledTag = styled(Tag)`
  min-height: 19px;
  padding: 0 5px 0 10px;
`;

export const ButtonTag = styled(StyledTag)`
  margin-left: 10px;
  padding: 2px 8px;

  @media (width <= 1200px) {
    padding: 1px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const RangeContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

export const SavePresetMessage = styled(Typography)`
  color: ${getPrefixedVar([...prefix, 'saveMessage'])};
  margin-bottom: 12px;
`;

export const StyledSwitchInput = styled(SwitchInput)`
  padding: 0 8px 0 20px;
  margin-bottom: 12px;
`;

export const SearchFilterInput = styled(SearchInput)`
  padding: 0 8px 0 20px;
  margin-bottom: 14px;
`;

export const ActionsButtons = styled.div`
  display: grid;
  grid-template-columns: 52% 48%;
  gap: 10px;
  padding: 12px 20px 16px;
  border-top-style: solid;
  ${getBorderBase([...prefix, 'actions'])};
`;

export const ShareButton = styled.div`
  grid-area: 1 / 1 / 2 / 3;

  & > div,
  button {
    width: 100%;
  }
`;

export const ApplyButton = styled(Button)`
  grid-area: 2 / 1 / 2 / 3;
`;
